// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider___cTvFf{margin:8px 0}.uploadInstructions___90eW2{font-size:16px;line-height:24px;margin-bottom:24px;margin-top:16px}\n", "",{"version":3,"sources":["webpack://./src/components/RulesBulkUpload/UploadInstructions/UploadInstructions.css"],"names":[],"mappings":"AAAA,iBAAA,YAAA,CAIA,4BACI,cAAA,CACA,gBAAA,CACA,kBAAA,CACA,eAAA","sourcesContent":[".divider {\n    margin: 8px 0;\n}\n\n.uploadInstructions {\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 24px;\n    margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": "divider___cTvFf",
	"uploadInstructions": "uploadInstructions___90eW2"
};
export default ___CSS_LOADER_EXPORT___;
